module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("aT9no"))).then(() => parcelRequire('d2QPY'));